import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d9e3933"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-login__item user-login__main" }
const _hoisted_2 = { class: "user-login__main-foot" }

import { ref, nextTick, onMounted } from 'vue';
import { BaseTabs, BaseTabPane, BaseButton } from 'xrk-components';
import { LoginForm } from '../components/login-base/index';

import type { FormRef, FormData } from '../types/index';
import { useSetup } from '../store';
import { LoginTypeEnum, FormItemEnum } from '../constants/index';

import { pwdLogIn, phoneLogin } from '../data-source/apis';


export default /*#__PURE__*/_defineComponent({
  __name: 'login-main',
  props: {
    "modelValue": {},
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

const FIELD_MAPPING = {
  bycode: [FormItemEnum.phone, FormItemEnum.agreement],
  bypassword: [FormItemEnum.account, FormItemEnum.pwd, FormItemEnum.agreement]
};

const model = _useModel(__props, "modelValue");

const loginStore = useSetup();

const formRef = ref<FormRef>(null);
const activeName = ref<'bycode' | 'bypassword'>('bycode');
const itemList = ref([]);
const currentForm = ref<FormData>({});

const toForget = () => {
  model.value = 'login-forget';
};
const getItemList = () => {
  itemList.value = FIELD_MAPPING[activeName.value];
};

const setAllData = () => {
  currentForm.value = { ...currentForm.value, ...formRef.value.data };
  return currentForm.value;
};

const setLoginData = () => {
  loginStore.setLoginData({
    ...formRef.value.data,
    activeName: activeName.value
  });
};
const onRegister = () => {
  setLoginData();
  model.value = 'login-register';
};

const onTabClick = () => {
  setLoginData();
  nextTick(() => {
    setAllData();
    getItemList();
    formRef.value.resetFields();
  });
};

const onForgotPwd = () => {
  setLoginData();
  setAllData();
  toForget();
};

const onLogin = async () => {
  await formRef.value.validate();
  const form = setAllData();
  let userInfo;
  // 密码登录
  if (activeName.value === 'bypassword') {
    const { data } = await pwdLogIn({
      [FormItemEnum.account]: form[FormItemEnum.account],
      [FormItemEnum.pwd]: form[FormItemEnum.pwd]
    });
    userInfo = data;
  }
  if (activeName.value === 'bycode') {
    const { data } = await phoneLogin({
      [FormItemEnum.phone]: form[FormItemEnum.phone],
      [FormItemEnum.code]: form[FormItemEnum.code],
      forgetThePassword: 0
    });
    userInfo = data;
  }
  loginStore.setInfo(userInfo);
  loginStore.login();
};
onMounted(() => {
  if (loginStore.loginData.activeName) {
    const { activeName: activeName2, ...formData } = loginStore.loginData;
    activeName.value = activeName2;
    currentForm.value = { ...formData };
  }
  getItemList();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseTabs), {
      class: "user-login__main-tabs",
      modelValue: activeName.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
      onTabClick: onTabClick
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(BaseTabPane), {
          label: "验证码登录",
          name: "bycode"
        }),
        _createVNode(_unref(BaseTabPane), {
          label: "密码登录",
          name: "bypassword"
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(LoginForm), {
      ref_key: "formRef",
      ref: formRef,
      itemList: itemList.value,
      formData: currentForm.value,
      pageType: _unref(LoginTypeEnum).MAIN
    }, null, 8, ["itemList", "formData", "pageType"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(BaseButton), {
        click: onLogin,
        class: "user-login__main-loginbtn"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 立即登录 ")
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        class: "user-login__main-forget",
        style: _normalizeStyle({
          justifyContent:
            activeName.value === 'bypassword' ? 'space-between' : 'flex-end'
        })
      }, [
        (activeName.value === 'bypassword')
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              onClick: onForgotPwd
            }, " 忘记密码 "))
          : _createCommentVNode("", true),
        _createElementVNode("p", null, [
          _createTextVNode(" 没有账号， "),
          _createElementVNode("span", {
            style: {"color":"var(--xrk-color-primary)"},
            onClick: onRegister
          }, " 注册 ")
        ])
      ], 4)
    ])
  ]))
}
}

})